import React, {Component} from 'react';
import styles from './IconBox.less';

export default class IconBox extends Component {
	render() {
		const {icon, children, className, ...props} = this.props;
		const {
			'icon-box': iconBoxClass,
			'icon-box__col': colClass,
			'icon-box__col_icon': colIconClass
		} = styles;

		return (
			<span className={[className, iconBoxClass].join(' ')} {...props}>
				<span className={[colClass, colIconClass].join(' ')}>{icon}</span>
				<span className={colClass}>{children}</span>
			</span>
		);
	}
}